import Cookies from 'js-cookie';
import { SESSION_NAME, TOKEN_NAME } from './environmentVariables';
import { UserType } from '../types/user';

// SESSION
export const getSessionDetails = () => {
  const data = Cookies.get(SESSION_NAME!);
  return data ? JSON.parse(data) : null;
};

export const storeSessionDetails = (sessionDetails: UserType) => {
  Cookies.set(SESSION_NAME!, JSON.stringify(sessionDetails), {
    secure: true,
    sameSite: 'strict',
  });
};

export const removeSessionDetails = () => {
  Cookies.remove(SESSION_NAME!);
};

// TOKEN
export const getTokenDetails = () => {
  return Cookies.get(TOKEN_NAME!) || null;
};

export const storeTokenDetails = (token: string) => {
  Cookies.set(TOKEN_NAME!, token, {
    secure: true,
    sameSite: 'strict',
    expires: 1 / 48,
  });
};

export const removeTokenDetails = () => {
  Cookies.remove(TOKEN_NAME!);
};
